<template>
  <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-18 mb-12 px-4">
    <div>
      <h2 class="text-center mx-auto max-w-6xl text-2xl sm:text-3xl lg:text-4xl font-medium mb-10">
        <span class="down-mark-line">
          {{ dataLocale.data.title }}
        </span>
      </h2>
      <p class="text-lg md:text-xl text-center" v-html="dataLocale.data.description">
        
      </p>
      <div class="flex flex-wrap justify-center items-center mt-12  gap-4 p-4">
        <div class="w-36 xs:w-40 sm:w-48 flex-shrink-0 mb-4" v-for="(img, i) in agencies" :key="i">
          <nuxt-img :src="'/agency/' + img" format="webp" :width="160" loading="lazy"
            :alt="'logo-' + img.replace('.png', '').toLowerCase() + '-company'" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import DataLocale from '~~/config/interface/DataLocale';

const agencies = ref([
  "PLES_grand.png",
  "anson.png",
  "blubrry.png",
  "jacob.png",
  "marketing-difference.png",
  "rosbeef.png",
  "adplorer.png",
  "aw.png",
  "gardner-literary.png",
  "lindwood.png",
  "romance.png",
  "triton.png",
],)

const dataLocale = new DataLocale([
  {
    locale: "en",
    title: "Our Customers",
    description: 'Trusted by over <span class="font-esbuild font-bold">1800</span> agencies and <span class="font-esbuild font-bold">30,000</span> companies worldwide.'
  }, {
    locale: "vi",
    title: "Khách hàng của chúng tôi",
    description: 'Được tin cậy bởi hơn <span class="font-esbuild font-bold">1800</span> đại lý và <span class="font-esbuild font-bold">30.000</span> công ty trên toàn thế giới.'
  },
  {
    locale: "zh",
    title: "我们的客户",
    description: '受全球超过<span class="font-esbuild font-bold">1800</span>家机构和<span class="font-esbuild font-bold">30,000</span>家公司的信赖。'
  },
  {
    locale: "ja",
    title: "私たちのお客様",
    description: '全世界<span class="font-esbuild font-bold">1800</span>社以上の代理店と<span class="font-esbuild font-bold">30,000</span>社以上の企業から信頼を得ています。'
  },
  {
    locale: "de",
    title: "Unsere Kunden",
    description: 'Vertrauenswürdig bei über <span class="font-esbuild font-bold">1800</span> Agenturen und <span class="font-esbuild font-bold">30.000</span> Unternehmen weltweit.'
  }, {
    locale: "fr",
    title: "Nos clients",
    description: 'Faites confiance à plus de <span class="font-esbuild font-bold">1800</span> agences et <span class="font-esbuild font-bold">30 000</span> entreprises dans le monde entier.'
  },
  {
    locale: "es",
    title: "Nuestros Clientes",
    description: 'Con la confianza de más de <span class="font-esbuild font-bold">1800</span> agencias y <span class="font-esbuild font-bold">30,000</span> empresas en todo el mundo.'
  },
  {
    locale: "pt",
    title: "Nosso Cliente",
    description: 'Confiado por mais de <span class="font-esbuild font-bold">1800</span> agências e <span class="font-esbuild font-bold">30.000</span> empresas em todo o mundo.'
  },
  {
    locale: "it",
    title: "I nostri clienti",
    description: 'Affidati da oltre <span class="font-esbuild font-bold">1800</span> agenzie e <span class="font-esbuild font-bold">30.000</span> aziende in tutto il mondo.'
  }, {
    locale: "nl",
    title: "Onze klanten",
    description: 'Vertrouwd door meer dan <span class="font-esbuild font-bold">1800</span> bureaus en <span class="font-esbuild font-bold">30.000</span> bedrijven over de hele wereld.'
  }
])

</script>
